// extracted by mini-css-extract-plugin
export default {"dropdown":"mimic___styles_dropdown__A6xUD","content":"mimic___styles_content__C6x3P","footer":"mimic___styles_footer__cAaUI"};